function showBlockdonate() {
    $(function () {
        $('#donate').dialog({
            autoOpen: !0,
            modal: !0,
            width: 736,
            open: function (e, n) {
                $('.ui-widget-overlay').bind('click', function () {
                    $('#donate').dialog('close')
                }),
                    $('body').addClass('overflowhidecs')
            },
            close: function (e, n) {
                $('body').removeClass('overflowhidecs')
            }
        })
    })
}
function showBlockPay() {
    $(function () {
        $('#payForm').dialog({
            autoOpen: !0,
            modal: !0,
            width: 736,
            open: function (e, n) {
                $('.ui-widget-overlay').bind('click', function () {
                    $('#payForm').dialog('close')
                }),
                    $('body').addClass('overflowhidecs')
            },
            close: function (e, n) {
                $('body').removeClass('overflowhidecs')
            }
        })
    })
}
function showGroupButton() {
    $(function () {
        $('#GroupButton').dialog({
            autoOpen: !0,
            modal: !0,
            width: 736,
            open: function (e, n) {
                $('.ui-widget-overlay').bind('click', function () {
                    $('#GroupButton').dialog('close')
                }),
                    $('body').addClass('overflowhidecs')
            },
            close: function (e, n) {
                $('body').removeClass('overflowhidecs')
            }
        })
    })
}
function showOlderVersions() {
    $(function () {
        $('#OlderVersions').dialog({
            autoOpen: !0,
            modal: !0,
            width: 736,
            open: function (e, n) {
                $('.ui-widget-overlay').bind('click', function () {
                    $('#OlderVersions').dialog('close')
                }),
                    $('body').addClass('overflowhidecs')
            },
            close: function (e, n) {
                $('body').removeClass('overflowhidecs')
            }
        })
    })
}
function showVirusModal() {
    $(function () {
        $('#VirusModal').dialog({
            autoOpen: !0,
            modal: !0,
            width: 736,
            open: function (e, n) {
                $('.ui-widget-overlay').bind('click', function () {
                    $('#VirusModal').dialog('close')
                }),
                    $('body').addClass('overflowhidecs')
            },
            close: function (e, n) {
                $('body').removeClass('overflowhidecs')
            }
        })
    })
}
function nextPage() {
    const e = $('#ajax-next-page a').attr('href')
    ShowLoading(''),
        $('#more').remove(),
        void 0 !== e &&
        $.ajax({
            url: e,
            success: function (e) {
                $('#more').remove(),
                    HideLoading(''),
                    $(),
                    $('#dle-content').append($('#dle-content', e).html())
            }
        })
}
function nextPageComments() {
    const e = $('#ajax-next-page a').attr('href')
    ShowLoading(''),
        $('#more').remove(),
        void 0 !== e &&
        $.ajax({
            url: e,
            success: function (e) {
                $('#more').remove(),
                    HideLoading(''),
                    $(),
                    $('.discuss').append($('.comm-list', e).html())
                $('#ajax-next-page a').attr('href')
                commLoaded()
            }
        })
}

function headerDropdown() {
    document.getElementById('logindrop').classList.toggle('show')
}

function headerDropdownLang() {
    document.getElementById('langDropdown').classList.toggle('show')
}

function headerDropdownMob() {
    document.getElementById('logindrop-mob').classList.toggle('show')
}


$(document).on('mouseup', function(e){
    let s = $('.dropdown-lang-content.show'); // берём .dropdown-lang-content.show
    if ( !s.is(e.target) && s.has(e.target).length === 0 ) {
        // Если нажат не он и не его дочерние элементы
        s.removeClass('show'); // То удаляем у него класс .show
    }
});

$('.logindrop-mob').click(function () {
    $('.dropdown-lang-content')
        .css('bottom', "-410px")
        .fadeIn({ queue: false })
        .animate(
            { bottom: "0" },
            { display: "block" },
            { queue: false, duration: 1000 }
        )
    $('.lang__init')
        .fadeIn({ queue: false })
        .animate({ queue: false })
});

$('.dropdown-lang-content').click(function () {
    $('.dropdown-lang-content')
        .css('bottom', "0")
        .animate(
            { bottom: "-410px" },
            { queue: false, duration: 1000 }
        )
        .fadeOut({ queue: false })
    $('.lang__init')
        .fadeOut({ queue: false })
        .animate({ queue: false })
});

$('.lang__init').click(function () {
    $('.dropdown-lang-content')
        .css('bottom', "0")
        .animate(
            { bottom: "-410px" },
            { queue: false, duration: 1000 }
        )
        .fadeOut({ queue: false })
    $('.lang__init')
        .fadeOut({ queue: false })
        .animate({ queue: false })
});


$('.open-nav').click(function () {
    $('.mob-nav-body')
        .css('bottom', "-410px")
        .fadeIn({ queue: false })
        .animate(
            { bottom: "0" },
            { display: "block" },
            { queue: false, duration: 1000 }
        )
    $('#mobile-bar')
        .fadeIn({ queue: false })
        .animate({ queue: false })
});

$('.box-icons-mob-close').click(function () {
    $('.mob-nav-body')
        .css('bottom', "0")
        .animate(
            { bottom: "-410px" },
            { queue: false, duration: 1000 }
        )
        .fadeOut({ queue: false })
    $('#mobile-bar')
        .fadeOut({ queue: false })
        .animate({ queue: false })
});

$(document).mouseup(function (e) {
    var container = $("#mobile-bar");
    if (container.has(e.target).length === 0) {
        container
            .fadeOut({ queue: false })
            .animate({ queue: false })
    }
});

Array.from(
    document.getElementsByClassName('summ'),
    (e) =>
    (e.textContent = e.textContent.replace(
        /(\d)(?=(\d\d\d)+([^\d]|$))/g,
        '$1 '
    ))
),
    $('.more-p').length &&
    ($('.more-p').each(function (e) {
        const n = $(this).height()
        $(this).data('height', n),
            n > 177 &&
            $(this)
                .addClass('minify_content-descritpion')
                .after('<a class="button_more btn-expand">ещё</a>')
    }),
        $(document).on('click', '.btn-expand', function () {
            const e = $(this)
            const n = e.prev('.minify_content-descritpion')
            e.hasClass('expanded')
                ? n.animate({ height: '177' }, 10, function () {
                    e.text('ещё').removeClass('expanded')
                })
                : n.animate({ height: n.data('height') }, 10, function () {
                    e.text('').addClass('expanded')
                })
        })),
    $('.more-p-info').length &&
    ($('.more-p-info').each(function (e) {
        const n = $(this).height()
        $(this).data('height', n),
            n > 72 &&
            $(this)
                .addClass('minify_content-descritpion_more')
                .after('<a class="button_more btn-expand">ещё</a>')
    }),
        $(document).on('click', '.btn-expand', function () {
            const e = $(this)
            const n = e.prev('.minify_content-descritpion_more')
            e.hasClass('expanded')
                ? n.animate({ height: '72' }, 10, function () {
                    e.text('ещё').removeClass('expanded')
                })
                : n.animate({ height: n.data('height') }, 10, function () {
                    e.text('').addClass('expanded')
                })
        })),
    $('.scora').length &&
    ($('.scora').each(function (e) {
        const n = $(this).height()
        $(this).data('height', n),
            n > 50 &&
            $(this)
                .addClass('minify_content-info')
                .after(
                    '<a class="button_arrow btn-expand"><i class="arrow" aria-hidden="true"></i></a>'
                )
    }),
        $(document).on('click', '.btn-expand', function () {
            const e = $(this)
            const n = e.prev('.minify_content-info')
            e.hasClass('expanded')
                ? n.animate({ height: '50' }, 10, function () {
                    e.html('<i class="strela" aria-hidden="true"></i>').removeClass(
                        'expanded'
                    )
                })
                : n.animate({ height: n.data('height') }, 10, function () {
                    e.html('').addClass('expanded')
                })
        })),
    (window.onclick = function (e) {
        if (!e.target.matches('.dropbtn')) {
            let n
            const t = document.getElementsByClassName('dropdown')
            for (n = 0; n < t.length; n++) {
                const o = t[n]
                o.classList.contains('show') && o.classList.remove('show')
            }
        }
    })

// Кнопка "Скопировать" в поле кода. На DLE не работает
// jQuery(document).ready(function ($) {
//     const $lang_Copy = ''
//     const $lang_Copy_Yes = ''
//     const $lang_Copy_Eror = 'Ошибка: Не удалось скопировать'

//     let copyid = 0
//     $('pre').each(function () {
//         copyid++
//         $(this).attr('data-copyid', copyid).wrap('<div class="pre-wrapper"/>')
//         $(this).parent().css('margin', $(this).css('margin'))
//         $('<button class="secondary copy-snippet">' + $lang_Copy + '</button>').insertAfter($(this)).data('copytarget', copyid)
//     })

//     $('body').on('click', '.copy-snippet', function (ev) {
//         ev.preventDefault()

//         const $copyButton = $(this)

//         $pre = $(document).find('pre[data-copyid=' + $copyButton.data('copytarget') + ']')
//         if ($pre.length) {
//             const textArea = document.createElement('textarea')

//             // Place in top-left corner of screen regardless of scroll position.
//             textArea.style.position = 'fixed'
//             textArea.style.top = 0
//             textArea.style.left = 0

//             // Ensure it has a small width and height. Setting to 1px / 1em
//             // doesn't work as this gives a negative w/h on some browsers.
//             textArea.style.width = '2em'
//             textArea.style.height = '2em'

//             // We don't need padding, reducing the size if it does flash render.
//             textArea.style.padding = 0

//             // Clean up any borders.
//             textArea.style.border = 'none'
//             textArea.style.outline = 'none'
//             textArea.style.boxShadow = 'none'

//             // Avoid flash of white box if rendered for any reason.
//             textArea.style.background = 'transparent'

//             // Set value to text to be copied
//             textArea.value = $pre.html()

//             document.body.appendChild(textArea)
//             textArea.select()

//             try {
//                 document.execCommand('copy')
//                 $copyButton.text($lang_Copy_Yes).prop('disabled', true)
//             } catch (err) {
//                 $copyButton.text($lang_Copy_Eror).prop('disabled', true)
//             }
//             setTimeout(function () {
//                 $copyButton.text($lang_Copy).prop('disabled', false)
//             }, 3000)
//         }
//     })
// })

// Close Pop-in If the user clicks anywhere else on the page
jQuery('html') //set for html for jsfiddle, but should be 'body'
    .bind(
        'click',
        function (e) {
            if (
                jQuery('.ui-dialog-content').dialog('isOpen')
                && !jQuery(e.target).is('.ui-dialog, a')
                && !jQuery(e.target).closest('.ui-dialog').length
            ) {
                jQuery('.ui-dialog-content').dialog('close');
            }
        }
    );

jQuery('html') //set for html for jsfiddle, but should be 'body'
    .bind(
        'click',
        function (e) {
            if (
                jQuery('#dleprofilepopup').dialog('isOpen')
                && !jQuery(e.target).is('.ui-dialog, a')
                && !jQuery(e.target).closest('.ui-dialog').length
            ) {
                jQuery('#dleprofilepopup').dialog('close');
            }
        }
    );

jQuery('html') //set for html for jsfiddle, but should be 'body'
    .bind(
        'click',
        function (e) {
            if (
                jQuery('#dlepopup').dialog('isOpen')
                && !jQuery(e.target).is('.ui-dialog, a')
                && !jQuery(e.target).closest('.ui-dialog').length
            ) {
                jQuery('#dlepopup').dialog('close');
            }
        }
    );


function Dropdown(element, toggleSelector = ".dropdown__toggle", menuSelector = ".dropdown__menu", menuItemSelector = ".dropdown__menu ul") {
    this.element = element
    this.toggler = element.querySelector(toggleSelector)
    this.menu = element.querySelector(menuSelector)

    this.toggleHandler = (event) => this.toggle(event)

    this.toggler.addEventListener('click', this.toggleHandler)
}

Dropdown.prototype.toggle = function (event) {
    const isexpanded = this.menu.dataset.expanded == 'true'

    // console.log(this, this.element, isexpanded, event)
    if (isexpanded) {
        this.menu.classList.remove('dropdown-menu-visible')
        document.removeEventListener('click', this.toggleHandler)

    } else {
        this.menu.classList.add('dropdown-menu-visible')
        setTimeout(() => document.addEventListener('click', this.toggleHandler), 10)

    }
    this.menu.dataset.expanded = '' + (!isexpanded)
}

function commLoaded() {
    document.querySelectorAll('.dropdown__selector').forEach(element => {
        new Dropdown(element)
    })
}

document.addEventListener('DOMContentLoaded', () => {
    commLoaded()
})


$(document).on('click', '.favmod', function(e){
    e.preventDefault();
    var $this = $(this);
    ShowLoading();
    $.ajax({
        url: dle_root + 'engine/mods/favorites/ajax.php',
        type: 'POST',
        dataType: 'json',
        data: {newsid: $this.data('id')},
    })
    .done(function() {
        $this.toggleClass('active');
    })
    .fail(function(error) {
        DLEalert(error.responseText, dle_info);
    })
    .always(function() {
        HideLoading();
    });
})

jQuery(function($){
    $(document).mouseup( function(e){ // событие клика по веб-документу
        var div = $( "#logindrop" ); // тут указываем ID элемента
        if ( !div.is(e.target) // если клик был не по нашему блоку
            && div.has(e.target).length === 0 ) { // и не по его дочерним элементам
            div.removeClass( "show" );
        }
    });
});

$(document).ready(function (){
    var allertid = $.cookie('allerttags')
    if(allertid =='none'){
        $('#allerttags').remove();
    }else{
        $('#allerttags').css('display', 'flex');
    }
    $('#closeallert').click(function() {
        $('#allerttags').css('display', 'none');
        $.cookie('allerttags', 'none', { expires: 2030});
    });
});

/* Top button  */
$(function() {
    // cache scroll to top button
    var b = $('#scroll_top');
    var c = $('#scroll_top_btn');
    // Hide scroll top button
    b.css('opacity', '0');

    // Animated smooth go to top
    c.on('click', function(){
        $('html,body').animate({
            scrollTop: 0
        }, 2000 );
        return false;
    });

    var $win = $(window);

    $win.scroll(function () {

        if ($win.scrollTop() > 1500) {
            b.css('opacity', '1');
            console.log("fadding in")
        } else {
            b.css('opacity', '0');
        }

        // Check if the window is almost at the bottom (-230 for the height of the footer)
        if ($win.height() + $win.scrollTop() >= $(document).height() - 72) {
            $('#scroll_top').addClass('stop_scroll_top');
        } else {
            $('#scroll_top').removeClass('stop_scroll_top');
        }
    });
});
